import React from "react";

import { HFlex } from "src/components/hFlex";
import { StatusIcon } from "src/components/icons";

import { BaseColumnConfig } from "./baseColumnConfig";

export class StatusColumn extends BaseColumnConfig<boolean> {
  compare(a: boolean = false, b: boolean = false) {
    return Number(a) - Number(b);
  }
  render(data: boolean = false) {
    return (
      <HFlex align="center" gap="xxs">
        <StatusIcon status={data ? "positive" : "disabled"} />
        {data ? "Enabled" : "Disabled"}
      </HFlex>
    );
  }
}
